<template>
  <nuttrema-layout-three-vertical>

    <participant-standard-header
       slot="top"
       v-if="!loading"
      :meta="meta"
      :showOnMobileAndTablet="showOnMobileAndTablet">
    </participant-standard-header>

    <template slot="middle">
      <nuttrema-loader v-if="RegionalAndLanguageAll.fetching"></nuttrema-loader>
      <form-login
         v-else
        :error="error"
        :class="showOnMobileAndTablet ? null : 'is-center-vertical'"
        :theme="showOnMobileAndTablet ? 'west-top' : null"
        :labelPosition="showOnMobileAndTablet ? 'top' : null"
        :PersonalProfile="PersonalProfile"
        :RegionalAndLanguageAll="RegionalAndLanguageAll"
        @emailChanged="onEmailChange"
        @changeLanguage="onChangeLanguage"
        @submit="onSubmit"
        @forgot-password="onForgotPassword">
      </form-login>
    </template>

  </nuttrema-layout-three-vertical>
</template>

<script>
import ResponsiveMonitor from 'components/mixins/responsive-monitor';
import ParticipantStandardHeader from 'components/pages/participant/shared/participant-standard-header';
import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';

import PageLogin from 'components/pages/shared/login/page-login';

export default {
  name: 'page-participant-login',
  mixins: [
    PageLogin,
    ResponsiveMonitor,
  ],
  components: {
    ParticipantStandardHeader,
    NuttremaLayoutThreeVertical,
  },
  methods: {
    onForgotPassword() {
      this.$router.push({ name: this.PAGES.PARTICIPANT.FORGOT_PASSWORD });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/participant/public/login/page-participant-login.vue